<template>
    <article
        id="policy-details-insured-item"
        data-test-policy-insured-item
    >
        <h2>{{ value.LabelInsuredItemHeadline }}</h2>

        <span
            v-for="(insuredperson, index) in value.InsuredPersons"
            :key="index"
        >

            <field
                v-model="insuredperson.Name"
                name="insured-person-name"
            />

            <field
                v-model="insuredperson.SocialSecurityNumber"
                name="social-security-number"
            />
        </span>
    </article>
</template>

<script>
import Field from '../Field.vue';

export default {
    name: 'ExtendedTravel',
    components: {
        Field
    },
    props: {
        value: {
            type: Object,
            default() {
                return null;
            }
        }
    }
};
</script>
